import { Switch } from 'react-router-dom';
import Route from './Route';
import { RastreioBusca, RastreioConsulta } from '../pages/MainPage';

export default function Routes() {
    return (
        <Switch>
            <Route path="/" exact component={RastreioBusca} />
            <Route path="/:codigoRastreio" exact component={RastreioConsulta} />
        </Switch>
    )
}